import { fileNameNormalizer } from '@app/shared/misc/fileNameNormalizer';

export const createPathState = () => {
  let path = '/';

  return {
    get currentRealPath() {
      return path;
    },

    append(segment: string) {
      const normalizedSegment = fileNameNormalizer(segment);
      if (!normalizedSegment) {
        return;
      }

      path = `${path}${normalizedSegment}/`;
    },

    up() {
      const segments = path.split('/').filter((s) => s.length > 0);
      if (segments.length === 0) {
        return;
      }

      segments.pop();
      path = segments.length > 0 ? `/${segments.join('/')}/` : '/';
    },

    reset() {
      path = '/';
    },
  };
};
